// extracted by mini-css-extract-plugin
export default {"button":"C-Qnty7TzZ","message-prev":"_2ZSWFFm7B_","messagePrev":"_2ZSWFFm7B_"};
    if(module.hot) {
      // 1623933242783
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  